import { FCT } from '@/i18n';

export const REASON_FOR_ACCESS = [
  FCT.REPORTING.HEADER.CONTACT_DETAILS.LABEL.EMERGENT,
  FCT.REPORTING.HEADER.CONTACT_DETAILS.LABEL.CONSULT,
  FCT.REPORTING.HEADER.CONTACT_DETAILS.LABEL.OTHER,
];
